module.exports = __webpack_public_path__ + "img/img_driver.ed167fec.jpg";